import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomDownloadButton from '../../../../../../components/CustomDownloadButton/CustomDownloadButton';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloudDownloadIcon from '../../../../../../components/Icons/CloudDownloadIcon';
import RefreshIcon from '../../../../../../components/Icons/RefreshIcon';
import { downloadDocumentoById } from '../../../../../../store/modules/ContratosActions';
import { getContentTypeByFileType } from '../../../../../../utils/FileUtils';
import { getElementID } from '../../../../../../utils/HTMLUtils';
import arquivosStyles from '../Arquivos.scss';

const INICITAL_STATE = {
  loading: false,
};

class DownloadAssinadoButton extends Component {
  constructor(props) {
    super(props);
    this.state = INICITAL_STATE;
  }

  getArquivoId = () => {
    return this.props.arquivo.idDocAssinado;
  };

  getFileName = () => {
    return (
      this.props.utils.getContratoAssinadoFileName() +
      '.' +
      this.props.arquivo.extencaoDocAssinado
    );
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      !arquivo.ativo ||
      !this.getArquivoId() ||
      arquivo.idDocAssinado == null ||
      this.props.contratosEntePublico.loadingAlteraArquivo
    );
  };

  setLoading = (loading) => {
    this.setState({
      loading,
    });
  };

  toDownload = (params, callbackProgress, callbackSuccess, callbackError) => {
    const onProgress = (event) => {
      callbackProgress(event.loaded / event.total);
    };
    this.props.downloadDocumentoById(
      params.id,
      params.contentType,
      onProgress,
      callbackSuccess,
      callbackError
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    return arquivo ? (
      <CustomDownloadButton
        hideLabel
        feedbackOnModal
        id={getElementID(this.props.id, 'download-assinado-' + arquivo.id)}
        className={arquivosStyles.rootClassName + '-action-button'}
        buttonComponent={CustomIconButton}
        buttonComponentProps={{
          theme: 'default',
          size: 'small',
          icon: this.state.loading ? <RefreshIcon /> : <CloudDownloadIcon color='#fff'/>,
          tooltip:
            this.props.languageValues.cadastroContratoArquivosDownloadAssinado,
          tooltipProps: {
            className:
              arquivosStyles.rootClassName + '-action-button-tooltip-caller',
          },
        }}
        fileName={this.getFileName()}
        downloadAction={this.toDownload}
        downloadActionData={{
          id: this.getArquivoId(),
          contentType: this.props.arquivo.extencaoDocAssinado
            ? getContentTypeByFileType(this.props.arquivo.extencaoDocAssinado)
            : null,
        }}
        feedbackOnModalTitle={
          this.props.languageValues.cadastroContratoArquivosDownloadingAssinado
        }
        disabled={this.isDisabled()}
        downloadActionStartCallback={() => this.setLoading(true)}
        downloadActionSuccessCallback={() => this.setLoading(false)}
        downloadActionErrorCallback={() => this.setLoading(false)}
      />
    ) : null;
  }
}

DownloadAssinadoButton.propTypes = {
  id: PropTypes.string.isRequired,
  refreshStep: PropTypes.func.isRequired,
  arquivo: PropTypes.object.isRequired,
  utils: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      downloadDocumentoById,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadAssinadoButton);
